import store from "@/store";
import { p2pActions } from "@/store/p2p-slice";

export const onP2PErrorHandler = (event: Event) => {
    console.error('WebSocket error:', event);
    store.dispatch(p2pActions.updateP2PSConnection('No Connection'))
};
